import { ButtonProps } from 'antd';
import { DefaultTheme } from 'styled-components';

export enum ButtonType {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	DANGER = 'danger',
	GHOST = 'ghost'
}

export enum ButtonSize {
	LARGE = 'large',
	SMALL = 'small'
}

export interface ITAButtonProps extends ButtonProps {
	btntype: ButtonType;
	btnSize?: ButtonSize;
	loading?: boolean;
	width?: string;
}

interface IButtonSizesMapper {
	[large: string]: { width: string; height: string };
	small: { width: string; height: string };
}

export const buttonSizesMapper: IButtonSizesMapper = {
	large: {
		width: '124px',
		height: '50px'
	},

	small: {
		width: '115px',
		height: '40px'
	}
};

interface IButtonStyles {
	backgroundColor: string;
	borderColor: string;
	text: {
		color: string;
		size: string;
		lineHeight: string;
	};
}

interface IButtonStates {
	default: IButtonStyles;
	hover: IButtonStyles;
	pressed: IButtonStyles;
	disabled: IButtonStyles;
}

interface IButtonTypesMapper {
	[ButtonType.PRIMARY]: IButtonStates;
	[ButtonType.SECONDARY]: IButtonStates;
	[ButtonType.GHOST]: IButtonStates;
	[ButtonType.DANGER]: IButtonStates;
}

export const buttonTypesMapper = (theme: DefaultTheme): IButtonTypesMapper => ({
	primary: {
		default: {
			backgroundColor: theme.BTN_PRIMARY_BG,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_TXT,
				size: '14px',
				lineHeight: '18px'
			}
		},

		hover: {
			backgroundColor: theme.BTN_PRIMARY_TXT,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '18px'
			}
		},
		pressed: {
			backgroundColor: theme.BTN_PRIMARY_TXT,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '20px'
			}
		},
		disabled: {
			backgroundColor: theme.TA_CLOUDY_BLUE,
			borderColor: theme.TA_DISABLED,
			text: {
				color: theme.TA_LIGHT,
				size: '14px',
				lineHeight: '20px'
			}
		}
	},
	secondary: {
		default: {
			backgroundColor: theme.BTN_SECONDARY_BG,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '20px'
			}
		},
		hover: {
			backgroundColor: theme.TA_WHITE,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '20px'
			}
		},
		pressed: {
			backgroundColor: theme.TA_WHITE,
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '20px'
			}
		},
		disabled: {
			backgroundColor: theme.TA_CLOUDY_BLUE,
			borderColor: theme.TA_DISABLED,
			text: {
				color: theme.TA_LIGHT,
				size: '14px',
				lineHeight: '20px'
			}
		}
	},
	danger: {
		default: {
			backgroundColor: theme.TA_ERROR,
			borderColor: theme.TA_ERROR,
			text: {
				color: theme.TA_WHITE,
				size: '14px',
				lineHeight: '20px'
			}
		},
		hover: {
			backgroundColor: '#ed3232',
			borderColor: '#ed3232',
			text: {
				color: theme.TA_WHITE,
				size: '14px',
				lineHeight: '20px'
			}
		},
		pressed: {
			backgroundColor: '#ed3232',
			borderColor: '#ed3232',
			text: {
				color: theme.TA_WHITE,
				size: '14px',
				lineHeight: '20px'
			}
		},
		disabled: {
			backgroundColor: '#ed6d6d',
			borderColor: '#ed6d6d',
			text: {
				color: theme.TA_WHITE,
				size: '14px',
				lineHeight: '20px'
			}
		}
	},
	ghost: {
		default: {
			backgroundColor: 'transparent',
			borderColor: theme.BTN_PRIMARY_BG,
			text: {
				color: theme.BTN_PRIMARY_BG,
				size: '14px',
				lineHeight: '20px'
			}
		},
		hover: {
			backgroundColor: 'transparent',
			borderColor: theme.TA_GREEN,
			text: {
				color: theme.TA_GREEN,
				size: '14px',
				lineHeight: '20px'
			}
		},
		pressed: {
			backgroundColor: 'transparent',
			borderColor: theme.TA_GREEN,
			text: {
				color: theme.TA_GREEN,
				size: '14px',
				lineHeight: '20px'
			}
		},
		disabled: {
			backgroundColor: 'transparent',
			borderColor: theme.TA_BLUISH_GREY,
			text: {
				color: theme.TA_BLUISH_GREY,
				size: '14px',
				lineHeight: '20px'
			}
		}
	}
});
